import React from 'react';

export const headIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="30"
    viewBox="0 0 28 30"
  >
    <defs>
      <linearGradient id="a" x1="-3.947%" x2="96.053%" y1="50%" y2="50%">
        <stop offset="51.02%" stopColor="#F2B997" />
        <stop offset="53.57%" stopColor="#EBAA87" />
      </linearGradient>
      <linearGradient id="b" x1="-4.147%" x2="95.853%" y1="50%" y2="50%">
        <stop offset="51.02%" stopColor="#F2B997" />
        <stop offset="53.57%" stopColor="#EBAA87" />
      </linearGradient>
      <linearGradient id="c" x1="-3.125%" x2="96.875%" y1="50%" y2="50%">
        <stop offset="51.53%" stopColor="#397DB9" />
        <stop offset="53.57%" stopColor="#2B66AB" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(3.5 4.884)">
        <path
          fill="#EBAA87"
          fillRule="nonzero"
          d="M18.9 16.744h-2.1v-2.79c0-1.187.91-2.094 2.1-2.094s2.1.907 2.1 2.093v.698c0 1.186-.91 2.093-2.1 2.093zM2.1 16.744h2.1v-2.79c0-1.187-.91-2.094-2.1-2.094S0 12.767 0 13.953v.698c0 1.186.91 2.093 2.1 2.093z"
        />
        <path
          fill="url(#a)"
          fillRule="nonzero"
          d="M16.38 22.884c-.91 1.256-2.94 2.232-4.48 2.232H9.1c-1.54 0-3.57-.976-4.48-2.232l-.84-1.117c-.91-1.255-1.68-3.488-1.68-5.023v-.697c0-1.535 1.26-2.791 2.8-2.791h11.2c1.54 0 2.8 1.256 2.8 2.79v.698c0 1.535-.77 3.768-1.68 5.023l-.84 1.117z"
        />
        <path
          fill="url(#b)"
          fillRule="nonzero"
          d="M18.9 16.047H2.1V7.744c0-6 3.78-6.349 8.4-6.349 4.62 0 8.4.35 8.4 6.35v8.302z"
        />
        <path
          fill="#987A5D"
          fillRule="nonzero"
          d="M18.2 4.605s-1.61 1.674-8.96 1.674C2.17 6.28 2.8 0 2.8 0h12.81l2.59 4.605zM19.6 11.86V8.372h-1.4v5.581c0 .768.63-2.093 1.4-2.093z"
        />
        <path
          fill="#987A5D"
          fillRule="nonzero"
          d="M13.3 0h-2.1v4.186h4.2c1.54 0 2.8 1.256 2.8 2.79v3.49h1.4V6.278C19.6 2.791 16.8 0 13.3 0zM1.4 11.86V8.372h1.4v5.581c0 .768-.63-2.093-1.4-2.093z"
        />
        <path
          fill="#987A5D"
          fillRule="nonzero"
          d="M7.7 0C4.2 0 1.4 2.79 1.4 6.28v4.185h1.4V6.977c0-1.535 1.26-2.791 2.8-2.791h4.2v6.28V0H7.7z"
        />
        <path
          fill="#CC856F"
          fillRule="nonzero"
          d="M11.9 16.047H9.1c0 .767.63 1.395 1.4 1.395.77 0 1.4-.628 1.4-1.395z"
        />
        <ellipse
          cx="14.35"
          cy="12.767"
          fill="#7B4C46"
          fillRule="nonzero"
          rx="1.05"
          ry="1"
        />
        <ellipse
          cx="6.65"
          cy="12.767"
          fill="#7B4C46"
          fillRule="nonzero"
          rx="1.05"
          ry="1"
        />
        <path
          stroke="#987A5D"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
          d="M12.6 10.326s.77-.559 1.75-.559c1.05 0 1.75.559 1.75.559M4.9 11.163h3.5"
        />
        <path
          stroke="#7B4C46"
          strokeLinecap="round"
          strokeWidth="1.4"
          d="M9.8 20.93s-1.82.28-2.8-1.395"
        />
      </g>
      <path
        fill="url(#c)"
        fillRule="nonzero"
        d="M4.9 5.581v6.07s3.92 2.302 9.1 2.302c5.32 0 9.1-2.302 9.1-2.302v-6.07H4.9z"
      />
      <path
        fill="#46A8D8"
        fillRule="nonzero"
        d="M27.37 5.093c.7.28.7.698 0 .977l-12.11 4.604c-.7.28-1.89.28-2.59 0L.63 6.07c-.7-.28-.7-.698 0-.977L12.74.488c.7-.279 1.89-.279 2.59 0l12.04 4.605z"
      />
      <path
        stroke="#E4AF34"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        d="M25.9 12.419V6.977L13.16 5.58"
      />
      <path
        stroke="#E4AF34"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
        d="M26.6 13.953h-1.4l.77-3.488h-.07z"
      />
    </g>
  </svg>
);
